import { memo, useCallback } from 'react';

import { useTrackAssetModalInfoPanelOpen } from '@air/analytics';
import { InfoIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

import { useAssetModalRightPanel } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';

export const AssetModalContentHeaderInfoPanelButton = memo(() => {
  const { isRightPanelOpen, showRightPanelTab } = useAssetModalRightPanel();
  const { trackAssetModalInfoPanelOpen } = useTrackAssetModalInfoPanelOpen();

  const handleShowInfoPanel = useCallback(() => {
    showRightPanelTab('info');
    trackAssetModalInfoPanelOpen();
  }, [showRightPanelTab, trackAssetModalInfoPanelOpen]);

  if (isRightPanelOpen) {
    return null;
  }

  return (
    <IconButton
      adsIcon
      icon={InfoIcon}
      label="Show Info Panel"
      appearance="ghost"
      color="gray"
      size="medium"
      onClick={handleShowInfoPanel}
    />
  );
});

AssetModalContentHeaderInfoPanelButton.displayName = 'AssetModalContentHeaderInfoPanelButton';
